exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._rpd-input-form[data-v-3e004ad3]{height:3rem;font-weight:400;font-size:18px;border-radius:10px}[data-v-3e004ad3]::-ms-input-placeholder{color:#e0e0e0!important}[data-v-3e004ad3]::placeholder{color:#e0e0e0!important}", ""]);

// exports
